import axios from 'src/utils/axios';

let tenantFeatureVisibilityRequest;

const getTenantFeatureVisibility = () => {
  if (!tenantFeatureVisibilityRequest) {
    tenantFeatureVisibilityRequest = axios
      .get('/GetTenantFeatureVisibility')
      .then((response) => response.data)
      .catch((error) => {
        tenantFeatureVisibilityRequest = null;
        throw error;
      });
  }

  return tenantFeatureVisibilityRequest;
};

export default getTenantFeatureVisibility;
